<template>
  <div class="todos text-center">
    <h2>Things to do</h2>
    <div v-if="isFetchingTodos">
      <v-skeleton-loader v-for="i in 10" :key="i" type="list-item-avatar" />
    </div>
    <div v-else>
      <v-list-item
        v-for="todoGroupedByDate in groupedTodos"
        :key="todoGroupedByDate.id"
      >
        <div class="full-width">
          <div
            v-for="todoGroupedByCategory in todoGroupedByDate"
            :key="todoGroupedByCategory.id"
            class="d-flex flex-column"
          >
            <TodoGroup
              :todoGroup="todoGroupedByCategory"
              data-test="todo-group"
            />
          </div>
        </div>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import TodoGroup from "@/components/todos/TodoGroup";
import { getGroupedTodos } from "@/utils/dashboard";

export default {
  props: {
    isFetchingTodos: Boolean,
    todos: {
      type: Array,
      required: true
    }
  },
  components: {
    TodoGroup
  },
  computed: {
    groupedTodos() {
      return getGroupedTodos(this.todos);
    }
  }
};
</script>

<style lang="scss"></style>
